import Text from 'shared/components/Text/Text';
import styled from 'styled-components';

export const VPPWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 48px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    margin-bottom: 96px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    margin-bottom: 120px;
  }
`;

export const VPPBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    width: 100%;
    margin-top: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    max-width: 505px;

    button {
      width: 294px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: row;
    max-width: 954px;
    margin-top: 96px;
    gap: 48px;
  }
`;

export const VPPTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 24px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    max-width: 505px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    order: -1;
    margin-top: 0;
    align-items: start;
  }
`;

export const Title = styled(Text)`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
`;

export const BodyTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
  font-weight: 300;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}) {
    gap: 16px;
  }
`;
